export const environment = {
  production: true,
  middlewareUrl: 'https://middleware.sensestream.org/',
  apiUrl: 'https://api.sensestream.org'
};
